export const CLOUD_BILLING_ADD_BOOKMARK = 'CLOUD_BILLING_ADD_BOOKMARK';

export const addBookmark = bookmark => (dispatch, getState) => {
    const {auth} = getState();

    dispatch({
        type:   CLOUD_BILLING_ADD_BOOKMARK,
        userId: auth.user.id,
        bookmark
    });
};

const _addBookmark = (stateBookmarks, bookmark) => {
    bookmark.id = stateBookmarks && stateBookmarks.length ? stateBookmarks[stateBookmarks.length - 1].id + 1 : 1;
    bookmark.name = `Custom Bookmark ${bookmark.id}`;

    return stateBookmarks ? [...stateBookmarks, bookmark] : [bookmark];
};


export const CLOUD_BILLING_DELETE_BOOKMARK = 'CLOUD_BILLING_DELETE_BOOKMARK';

export const deleteBookmark = bookmark => (dispatch, getState) => {
    const {auth} = getState();

    dispatch({
        type:   CLOUD_BILLING_DELETE_BOOKMARK,
        userId: auth.user.id,
        bookmark
    });
};

const _deleteBookmark = (stateBookmarks, id) => stateBookmarks.filter(bookmark => bookmark.id !== id);


export const CLOUD_BILLING_UPDATE_BOOKMARK = 'CLOUD_BILLING_UPDATE_BOOKMARK';

export const updateBookmark = (id, update) => (dispatch, getState) => {
    const {auth} = getState();

    dispatch({
        type:   CLOUD_BILLING_UPDATE_BOOKMARK,
        userId: auth.user.id,
        id, update
    });
};

const _updateBookmark = (bookmarks, id, update) => bookmarks.map(bookmark => {
    if (id === bookmark.id) {
        Object.keys(update).forEach(key => { bookmark[key] = update[key] });
    }

    return bookmark;
});


export const CLOUD_BILLING_FIX_BOOKMARKS = 'CLOUD_BILLING_FIX_BOOKMARKS';

export const fixBookmarks = () => (dispatch, getState) => {
    const {auth} = getState();

    dispatch({
        type:   CLOUD_BILLING_FIX_BOOKMARKS,
        userId: auth.user.id
    });
};

const _fixBookmarks = (stateBookmarks, userId) => Array.isArray(stateBookmarks) ? stateBookmarks : stateBookmarks[userId];


// Reducer
const _defaultState = () => ({
    bookmarks: {}
});


export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case CLOUD_BILLING_ADD_BOOKMARK:
        return {
            ...state,
            bookmarks: {
                ...state.bookmarks,
                [action.userId]: _addBookmark(state.bookmarks[action.userId], action.bookmark)
            }
        };
    case CLOUD_BILLING_DELETE_BOOKMARK:
        return {
            ...state,
            bookmarks: {
                ...state.bookmarks,
                [action.userId]: _deleteBookmark(state.bookmarks[action.userId], action.bookmark.id)
            }
        };
    case CLOUD_BILLING_UPDATE_BOOKMARK:
        return {
            ...state,
            bookmarks: {
                ...state.bookmarks,
                [action.userId]: _updateBookmark(state.bookmarks[action.userId], action.id, action.update)
            }
        };
    case CLOUD_BILLING_FIX_BOOKMARKS:
        return {
            bookmarks: {
                [action.userId]: _fixBookmarks(state.bookmarks, action.userId)
            }
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/cloudBillingBookmarks.js